module.exports = __webpack_public_path__ + "media/images/icons/icons_small/8_calendar-8be5b86b2835700e442b48a42f2736a7.png";